import { render, staticRenderFns } from "./AdminManager.vue?vue&type=template&id=0f132f98&"
import script from "./AdminManager.vue?vue&type=script&lang=js&"
export * from "./AdminManager.vue?vue&type=script&lang=js&"
import style0 from "./AdminManager.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f132f98')) {
      api.createRecord('0f132f98', component.options)
    } else {
      api.reload('0f132f98', component.options)
    }
    module.hot.accept("./AdminManager.vue?vue&type=template&id=0f132f98&", function () {
      api.rerender('0f132f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminManager.vue"
export default component.exports